"use client";

import dynamic from "next/dynamic";
import type { HeroTextureProps } from "./HeroTextureClient";

const HeroTextureClient = dynamic(() => import("./HeroTextureClient").then(mod => mod.HeroTextureClient));

export function HeroTextureLazy(props: HeroTextureProps) {
  return <HeroTextureClient {...props} />;
}
